// extracted by mini-css-extract-plugin
export default {"layout":"Palette_layout__CIQge","horizontal":"Palette_horizontal__rJPWa","vertical":"Palette_vertical__Msbgk","active":"Palette_active__61P6Z"};